export enum PreviewSessionStatus {
  ACTIVE = 'ACTIVE',
  TERMINATING = 'TERMINATING',
}

export enum PreviewOperation {
  INITIATE = 'initiate',
  TERMINATE = 'terminate',
}

/** Persisted session entry stored in localStorage */
export interface PersistedPreviewSession {
  deviceId: string;
  /** Device Serial Number — for display only; deviceId remains the logical identifier */
  dsn?: string;
  customerId: string;
  creativeId: string;
  /** Expiration timestamp in milliseconds (Date.now() compatible) */
  expiresAt: number;
  marketplace: string;
  deviceFamily: string;
  placement: string;
}

/** Session entry exposed to UI - includes ephemeral status */
export interface PreviewSessionEntry extends PersistedPreviewSession {
  status: PreviewSessionStatus;
}

/** Input for creating a new session (context fields injected by hook) */
export type PreviewSessionInput = Omit<
  PersistedPreviewSession,
  'marketplace' | 'deviceFamily' | 'placement'
>;

const CONTACT_SUPPORT_SUFFIX = ' If the issue persists, please contact support.';

export const PREVIEW_ERROR_MESSAGES = {
  CONFLICT:
    'This customer ID is already in use by another user. Please try a different customer ID.',
  INVALID_INPUT: 'Invalid input provided.',
  CREATIVE_NOT_FOUND: 'Creative not found. Please verify the creative ID and try again.',
  SESSION_NOT_FOUND: 'Preview session not found. It may have already expired or been terminated.',
  INTERNAL_ERROR: `Something went wrong. Please try again later.${CONTACT_SUPPORT_SUFFIX}`,
  GENERIC_INITIATE: `Failed to start preview. Please try again.${CONTACT_SUPPORT_SUFFIX}`,
  GENERIC_TERMINATE: `Failed to terminate preview. Please try again.${CONTACT_SUPPORT_SUFFIX}`,
} as const;
